<template>
  <div v-if="item.validations?.length > 1"
       class="my-2 text-caption font-weight-bold text-text-secondary"
  >
    {{ $t('project.project-settings.signatures.ProjectSettingsSignaturesValidatorsList.validatorsList') }}
  </div>

  <div class="d-flex flex-column row-gap-2">
    <ProjectSettingsSignaturesValidator v-for="(validation, index) in item.validations"
                                        :key="`validation-${index}`"
                                        :validation="validation"
                                        :item="item"
    />
  </div>
</template>

<script>
import ProjectSettingsSignaturesValidator from './ProjectSettingsSignaturesValidator.vue'

export default {
  name: 'ProjectSettingsSignaturesValidatorsList',
  components: { ProjectSettingsSignaturesValidator },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
